var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCoinbase = function SvgCoinbase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2059EB",
    d: "M20 0C8.944 0 0 8.944 0 20c0 11.053 8.944 20 20 20 11.053 0 20-8.947 20-20C40 8.944 31.053 0 20 0m0 31.702c-6.46 0-11.703-5.243-11.703-11.703S13.54 8.297 20 8.297 31.702 13.54 31.702 20 26.459 31.702 20 31.702"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2059EB",
    d: "M22.838 23.755h-5.676a.9.9 0 0 1-.892-.892v-5.702a.9.9 0 0 1 .891-.892h5.703a.9.9 0 0 1 .892.892v5.703a.906.906 0 0 1-.919.892"
  })));
};
export default SvgCoinbase;